<div *ngIf="!isLoading">
    <div *ngIf="isEmptyResult && !isFiltered && !isServiceUnavailable" class="empty-result-message">
        <div class="icon-64 list"></div>

        <span>
            <ng-content></ng-content>
        </span>
    </div>

    <div *ngIf="isEmptyResult && isFiltered && !isServiceUnavailable" class="empty-result-message">
        <div class="icon-64 search"></div>
        <span>Results Not Found</span>
        <broad-match-toggle></broad-match-toggle>
    </div>

    <div *ngIf="isServiceUnavailable" class="empty-result-message">
        <div class="icon-64 crossed"></div>
        <span>Service Unavailable</span>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/fields/empty-result-message/empty-result-message.component.html